// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-label[data-v-3c7ad1f2]{font-style:normal;font-weight:bold;font-size:14px;line-height:17px;color:#000}", ""]);
// Exports
module.exports = exports;
